import CONSTANTS from '../../_constants';
import { ToastStateInterface, toastInitialState } from '../state/toast';

export default function toastReducer(state: ToastStateInterface = toastInitialState, action: any): ToastStateInterface {
  switch (action.type) {
    case CONSTANTS.TOAST_DISPATCH:
      return {
        ...state,
        active: true,
        type: action.payload.type,
        data: state.data.concat(action.payload.data),
        quantities: action.payload.quantities
          ? state.quantities.concat(action.payload.quantities)
          : state.quantities,
      };
    case CONSTANTS.TOAST_HIDE:
      return { ...state, isShowing: false };
    case CONSTANTS.TOAST_SHOW:
      return { ...state, isShowing: true };
    case CONSTANTS.TOAST_DISMISS:
      return { ...state, active: false, type: '', data: [], quantities: [] };
    default:
      return state;
  }
}